import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { VehicleList } from '../../../api/models/vehicle-list';
import { PaymentInfo } from '../../../api/models/payment-info';
import { trigger, style, animate, transition } from '@angular/animations';
import { CookieHelperService } from '../../services/cookie-helper.service';

@Component({
  selector: 'app-disclaimer-popup',
  templateUrl: './disclaimer-popup.component.html',
  styleUrls: ['./disclaimer-popup.component.scss'],
  animations: [
    trigger('fadeInOut', [
        transition(':enter', [
            style({opacity: 0}),
            animate(200, style({opacity: 1}))
        ]),
        transition(':leave', [
            animate(200, style({opacity: 0}))
        ])
    ])
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DisclaimerPopupComponent implements OnInit {

  popThisUp = false;
  fscore: any;
  @Input() vehicle: PaymentInfo;
  @Input() mode: 'inline' | 'question-mark' = 'inline'

  constructor(
    private cookieService: CookieHelperService,
  ) { }

  ngOnInit() {
    this.fscore = this.cookieService._getCookie('fscore');
  }

  mouseEnter() {
    this.popThisUp = true;
  }

  mouseLeave() {
    this.popThisUp = false;
  }

  clickLeave() {

    if (this.popThisUp === true) {
        this.popThisUp = false;
    } else {
        this.popThisUp = true;
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/disclaimer-popup/disclaimer-popup.component.ts